import { render, staticRenderFns } from "./JdhSizeDetector.vue?vue&type=template&id=d78098b4&scoped=true&"
import script from "./JdhSizeDetector.vue?vue&type=script&lang=ts&"
export * from "./JdhSizeDetector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78098b4",
  null
  
)

export default component.exports